import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-about',
    templateUrl: 'about.component.html',
    styleUrls: ['../pages.scss', './about.component.scss'],
})

export class AboutComponent  {

    activeLanguage = 'german';
    activeContent: string;
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => {
          this.activeLanguage = val;
      });
    }
    content = {
        german: `<div class="row margin-below">
        <div class="col">
          <h1 class="header">Über TCW</h1>
        </div>
      </div>
      <div class="row">
        <div class="text-content col-md-6 col-12">
            <p>
                <span class="highlight">Technologie Consulting Wolke</span> bietet unabhängige Servicedienstleistungen
                für Technologie-orientierte Unternehmen und Branchen an. Mit langjähriger Erfahrung in unterschiedlichen
                Bereichen erarbeiten und realisieren wir für und mit unseren Kunden Lösungen gleichermaßen für aktuelle
                Probleme  wie auch strategische Fragestellungen.
            </p>

            Unsere Beratungsschwerpunkte sind:
          <ul>
            <li>Erarbeitung und Implementierung von Sauberkeitskonzepten für technisch anspruchsvolle Produkte
            speziell für die Fertigung in reiner Umgebung</li>
            <li>Optimierung der Entwicklungsprozesse</li>
            <li>Planung und Aufbau von High Tech Produktionslinien</li>
            <li>Effizienz- und Produktivitätssteigerung in der Fertigung</li>
            <li>Produktzuverlässigkeit und Qualitätssicherung</li>
            <li>Qualifikation / Validierung von Produktionsprozessen nach branchenspezifischer Regularien ((GMP, FDA, TS 16949)</li>
            <li>Strategische Geschäftsfeldentwicklung (Produktportfolio, Erschließen neuer Märkte)</li>
          </ul>
        </div>
        <div class="image image-centered col-md-6 col-12">
          <img class="img-responsive" src="/assets/platine.jpg">
        </div>
      </div>`,
      english: `
      <div class="row margin-below">
        <div class="col">
          <h1 class="header">About TCW</h1>
        </div>
      </div>
      <div class="row">
      <div class="text-content col-md-6 col-12">
          <p>
            <span class="highlight">Technologie Consulting Wolke</span> provides independent advisory services for
            technology-oriented enterprises and markets. We utilize many years of experience in various business areas
            to establish and implement sustainable solutions for and with our customers on urging problems as well as
            strategic improvements.
          </p>
          <span class="highlight">TCW</span> services include:
          <ul>
            <li>Designing, Forming and implementing concepts of clean manufacturing technology for products with
            strong and specific cleanliness requirements.</li>
            <li>Identification and elimination of defects for operation and production in clean environment.</li>
            <li>Planning and installation of high tech production lines</li>
            <li>Optimization of business processes in research, product development and qualification</li>
            <li>Improvement of effectiveness and productivity in high-tech manufacturing, in particular semiconductors and automotive</li>
            <li>Qualification, stabilization and validation of production processes</li>
            <li>Reliability and product assurance</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="image image-centered col-md-6 col-12">
          <img class="img-responsive" src="/assets/platine.jpg">
        </div>
      </div>`,
    };

}



// WEBPACK FOOTER //
// ./src/app/components/about/about.component.ts